export const ALLOWED_FILE_TYPES = [
  '.pdf',
  '.doc',
  '.docx',
  '.txt',
  '.md',
  '.pptx',
  '.ppt',
] as const;

export const ALLOWED_MIME_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain',
  'text/markdown',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
];

export const MAX_FILE_SIZE_MB = 200;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const DEFAULT_TOP_K = 10;

export const QUERY_HISTORY_KEY = 'kb_query_history';
export const QUERY_RESULT_CACHE_KEY = 'kb_query_result_cache';
export const MAX_QUERY_HISTORY = 20;

export const DOCUMENT_STATUS_COLORS = {
  ready: '#11B868',      // success.main
  processing: '#F0AD56', // warning.main
  failed: '#C30A07',     // error.main
};
